<template>
  <v-dialog v-model="dialog" width="90%">
    <v-card elevation="3">

      <div class="pp-sidenav">
        <v-card-title class="white--text">
          Add an Image
        </v-card-title>

        <v-card-subtitle class="white--text">
          Add details below
        </v-card-subtitle>
      </div>

      <v-img
          src="/images/pp-logo.png"
          height="40"
          contain
          class="logo-course"
      >
      </v-img>

      <v-tabs dark
              width="250"
              color="primary"
              vertical>
        <v-tab class="pp-sidenav-2">
          <v-icon left>
            mdi-plus
          </v-icon>
          Upload an Image
        </v-tab>

        <v-tab-item>
          <v-card flat>
            <v-container>
              <template>
                <v-card
                    color="grey lighten-4"
                    width="100%" flat
                >
                  <v-card-title class="text-h6 grey lighten-3">
                    Select an image
                  </v-card-title>

                  <v-row class="mx-5 mt-5">
                    <v-card-title>
                      Select an image from your local device
                    </v-card-title>
                  </v-row>

                  <v-card-text>
                    <v-row class="mx-5">

                      <v-img :src="previewImage" class="mb-5 px-20" max-height="300" contain></v-img>

                      <v-file-input
                          show-size
                          label="Select a .jpg or .png file"
                          accept="image/*"
                          @change="selectImage"
                          placeholder="Select a .jpg or .png file"
                          solo
                          flat
                          small-chips
                          v-model="image"
                          style="width: 100%"
                          height="150"
                          hint="Must be a .jpg or .png file"
                          persistent-hint
                          class="mb-10"
                      ></v-file-input>
                    </v-row>
                    <v-row v-if="imageApiError && imageApiError.fields && imageApiError.fields.image" class="err-text">
                      <p class="error--text">
                        An image should be chosen.
                      </p>
                    </v-row>
                    <v-row v-if="imageApiError">
                      <v-alert
                          text
                          color="red"
                          icon="mdi-alert-circle-outline"
                      >
                        There was an error in submission. Please check all fields and try again.
                      </v-alert>
                    </v-row>
                  </v-card-text>
                </v-card>
              </template>
            </v-container>
          </v-card>
        </v-tab-item>
      </v-tabs>

      <!-- ------------------------------------------ buttons ------------------------------------------ -->
      <div class="pp-sidenav">
        <div class="btm">

          <Loading v-if="imageItemLoading" />

          <ConfirmCancelButtons
              :item="add"
              confirm-text="Create Image"
              :confirm-action="addItemConfirm"
              :cancel-action="closeDialog"
              :confirm-disabled="imageItemLoading"/>
        </div>
      </div>
      <!-- ------------------------------------------end of buttons ------------------------------------------ -->
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ConfirmCancelButtons from "@/components/common/ConfirmCancelButtons";
import Loading from "@/components/common/Loading";

export default {
  name: "ImageAdd",
  components: {
    Loading, ConfirmCancelButtons,
  },
  data() {
    return {
      add: {
        file: '',
      },
      previewImage: null,
      image: null,
    };
  },
  computed: {
    ...mapGetters(['imageApiError', 'openDialog', 'imageItemLoading']),
    dialog: {
      get () {
        return this.openDialog === 'imageAdd';
      },
      set(value) {
        this.setOpenDialog(value);
      },
    },
  },
  methods: {
    ...mapActions(['addImage', 'setOpenDialog', 'closeOpenDialog']),
    selectImage() {
      this.previewImage = URL.createObjectURL(this.image);
    },
    closeDialog() {
      this.reset();
    },
    async addItemConfirm() {
      const added = await this.addImage(this.image);

      if (added) {
        this.reset();
      }
    },
    reset() {
      this.closeOpenDialog();
      this.previewImage = null;
      this.image = null;
      this.add = {
        file: '',
      };
    },
  },
};
</script>
